import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSCBillWatchAWSEstimator, NSCBillWatchAzureEstimator, NSCBillWatchGCPEstimator, NSCLogLogGroupEstimator } from "namirasoft-cost-react";
import { ProductRow } from "namirasoft-payment";
import { NSBoxEntity, NSNoData, NSRow, NSSection, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { Component, Fragment, ReactNode } from "react";
import { CostLayout } from "../CostLayout";
import { CostRouterProps } from "../CostRouterProps";

interface CostEstimatorPageProps extends NSARouterMakerResult, CostRouterProps { }

interface CostEstimatorPageState
{
    selectedProductID: string | null;
}

class CostEstimatorPage extends Component<CostEstimatorPageProps, CostEstimatorPageState>
{
    private Estimators = [
        new NSCBillWatchAWSEstimator(),
        new NSCBillWatchAzureEstimator(),
        new NSCBillWatchGCPEstimator(),
        new NSCLogLogGroupEstimator(),
    ];

    constructor(props: CostEstimatorPageProps)
    {
        super(props);
        this.state = { selectedProductID: null }
    }

    override render()
    {
        let product_ids = [...new Set(this.Estimators.map(e => e.getProductID()))];
        let filtered_estimators = this.Estimators.filter(estimator => estimator.getProductID() === this.state.selectedProductID).map((estimator, index) =>
        {
            return (
                <Fragment key={estimator.getProductID() + index}>
                    {estimator.render()}
                </Fragment>
            );
        });

        let content: ReactNode = filtered_estimators;

        if (filtered_estimators.length === 0)
            content = <NSNoData
                lable="Please select a product to see the estimators"
                style={{ maxWidth: "40rem", padding: "1.5rem 1.5rem 3rem" }}
            />;

        return (
            <CostLayout
                {...this.props}
                action={{
                    title: "Estimator",
                    description: "This section allows you to choose a product and enter usage data to estimate the cost of using that product under specific conditions.",
                    menus: {}
                }}
            >
                <NSSection>
                    <NSBoxEntity<ProductRow>
                        title="Product"
                        multiple={false}
                        required={false}
                        table_name="product"
                        list={async (filters, page, size, sorts) =>
                        {
                            let res = await this.props.servers.payment.product.List(filters, page, size, sorts, null);
                            res.rows = res.rows.filter(r => product_ids.includes(r.id));
                            return res;
                        }}
                        onChanged={(entity) => this.setState({
                            selectedProductID: entity.getValueOne()
                        })}
                        getTitle={(item) => item.name}
                        getValue={(item) => item.id}
                        getSort={() => null}
                        info={{ link: "https://namirasoft.com/cost/console-guide/estimator/#field-product" }}
                    />
                    <NSSpace size={NSSpaceSizeType.MEDUIM} />
                    <NSRow>
                        {content}
                    </NSRow>
                </NSSection>
            </CostLayout>
        );
    }
}
export default CostEstimatorPage;